import * as _ from 'underscore';

import * as config from '../config';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

import BooleanField from '../../../../_common/platform/ts/BooleanField';

const _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: config.themeId,
            name: config.name,
            parent: 'widget',

            themeType: config.name,
            visibility: ['application', 'workspace', config.moduleName]
        }
    ]);

    appTheme.registerVars([
        {
            id: config.themeFields.makeFiltersLocal,
            param: new BooleanField(glob, 'Make Filters Local', [], true),
            section: config.themeId
        },
        {
            id: config.themeFields.useGridLayoutOnMobileDevices,
            param: new BooleanField(glob, 'Do not use Carousel Layout on Mobile Devices', [], false),
            section: config.themeId
        }
    ]);

    _init.push(glob);
}
